var _path, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _rect, _rect2, _rect3, _path2, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 364 394"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1D2035",
  d: "M104 248.5V261a8 8 0 0 0 8 8h26.5c5.523 0 10 4.477 10 10v41.5m106-72V272a6 6 0 0 1-6 6H197a6 6 0 0 0-6 6v10.5a6 6 0 0 0 6 6h106a6 6 0 0 1 6 6v14"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 148.5,
  cy: 299.5,
  r: 1.5,
  fill: "#575C88"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_2227_10600)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 148.5,
  cy: 299.5,
  r: 1.5,
  fill: "#E6E7ED"
}))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 107.5,
  cy: 267.5,
  r: 1.5,
  fill: "#575C88"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_2227_10600)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 107.5,
  cy: 267.5,
  r: 1.5,
  fill: "#E6E7ED"
}))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 254.5,
  cy: 267.5,
  r: 1.5,
  fill: "#575C88"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_2227_10600)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 254.5,
  cy: 267.5,
  r: 1.5,
  fill: "#E6E7ED"
}))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 214.5,
  cy: 300.5,
  r: 1.5,
  fill: "#575C88"
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_2227_10600)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 214.5,
  cy: 300.5,
  r: 1.5,
  fill: "#E6E7ED"
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 222,
  height: 222,
  x: 71,
  y: 26,
  stroke: "#1D2035",
  strokeWidth: 2,
  rx: 19
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_f_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 148,
  height: 148,
  x: 106,
  y: 76,
  fill: "#040717",
  fillOpacity: 0.43,
  rx: 17,
  style: {
    mixBlendMode: "darken"
  }
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 146,
  height: 146,
  x: 109,
  y: 64,
  stroke: "#343C50",
  strokeWidth: 2,
  rx: 20
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 141,
  height: 141,
  x: 111.5,
  y: 66.5,
  fill: "#141726",
  stroke: "#090B1C",
  strokeWidth: 3,
  rx: 18.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear_2227_10600)",
  fillOpacity: 0.06,
  d: "M114 85c0-9.389 7.611-17 17-17h102.127c11.685 0 19.757 11.46 15.288 22.257-9.233 22.312-24.897 55.725-41.915 72.743-16.799 16.799-48.603 32.085-70.174 41.215-10.794 4.569-22.326-3.493-22.326-15.214V85Z"
})), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  fill: "#3F485E",
  filter: "url(#filter7_i_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M142.015 143.71H129v-19.487h3.839v16.202h9.176v3.285Zm13.778-7.488c0 .501-.028 1.113-.056 1.392h-10.559c.311 2.115 1.694 3.368 3.727 3.368 1.666 0 2.851-.779 3.218-2.143l3.332.89c-.791 2.645-3.275 4.204-6.607 4.204-4.714 0-7.227-3.591-7.227-7.238 0-3.647 2.315-7.238 7.03-7.238 4.799 0 7.142 3.507 7.142 6.765Zm-10.53-1.17h6.719c-.169-1.67-1.27-2.923-3.331-2.923-1.751 0-2.993 1.03-3.388 2.923Zm21.324-3.953v-1.42h3.528v13.141c0 3.702-2.823 6.18-7.057 6.18-3.332 0-6.014-1.754-6.494-4.371l3.303-.529c.17 1.309 1.525 2.088 3.191 2.088 2.145 0 3.557-1.197 3.557-3.006v-1.532c-.706 1.003-2.259 1.643-3.953 1.643-4.178 0-6.634-2.784-6.634-6.904 0-4.148 2.456-6.932 6.55-6.932 1.75 0 3.218.668 4.009 1.642Zm-3.416 9.159c2.202 0 3.641-1.531 3.641-3.869 0-2.367-1.439-3.898-3.641-3.898-2.174 0-3.614 1.531-3.614 3.898 0 2.338 1.44 3.869 3.614 3.869Zm17.185 3.452h-4.009l-5.759-19.487h3.952l3.811 14.977 3.868-14.977h4.348l3.896 14.977 3.811-14.977h3.952l-5.703 19.487h-4.065l-4.037-14.281-4.065 14.281Zm23.545.223c-4.319 0-7.425-3.062-7.425-7.238s3.106-7.238 7.425-7.238 7.425 3.062 7.425 7.238-3.106 7.238-7.425 7.238Zm0-3.034c2.287 0 3.839-1.699 3.839-4.204 0-2.506-1.552-4.204-3.839-4.204-2.315 0-3.84 1.698-3.84 4.204 0 2.505 1.525 4.204 3.84 4.204Zm17.807-11.22-.226 3.397c-.508-.223-1.186-.334-1.807-.334-2.004 0-3.811 1.642-3.811 5.818v5.15h-3.557v-14.031h3.557v2.562c.706-1.587 2.569-2.784 4.291-2.784.508 0 1.129.083 1.553.222ZM236 143.71h-4.291l-4.376-6.18-1.666 1.615v4.565h-3.585V124h3.585v10.663l5.364-4.984h4.517l-5.787 5.54L236 143.71Z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_d_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#070813",
  d: "M108 128H82"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_d_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#070813",
  d: "M282 128h-26"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_d_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#070813",
  d: "M108 135H82"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_d_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#070813",
  d: "M282 135h-26"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_d_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#070813",
  d: "M108 142H82"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_d_2227_10600)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#070813",
  d: "M282 142h-26"
}))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 214,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 222,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 230,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 238,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 246,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 254,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 262,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 270,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 214,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 214,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 222,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 222,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-2)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 230,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 230,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 238,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 238,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 246,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 246,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 254,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 254,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-6)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 262,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 262,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
  className: "bulb green-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#green-blur-7)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 270,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 270,
  y: 222,
  fill: "#A5E6CE",
  rx: 2
}))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 90,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 98,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 106,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter25_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 114,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter26_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 122,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter27_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 130,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter28_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 138,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter29_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 146,
  y: 222,
  fill: "#070707",
  rx: 2
}))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 90,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 90,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 98,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 98,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-2)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 106,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 106,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 114,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 114,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 122,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 122,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 130,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 130,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-6)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 138,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 138,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
  className: "bulb yellow-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#yellow-blur-7)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 146,
  y: 222,
  fill: "#AD8C35",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 146,
  y: 222,
  fill: "#AD8C35",
  rx: 2
}))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter30_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 214,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter31_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 222,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter32_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 230,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter33_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 238,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter34_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 246,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter35_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 254,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter36_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 262,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter37_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 270,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 214,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 214,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 222,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 222,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-2)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 230,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 230,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 238,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 238,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 246,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 246,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 254,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 254,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-6)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 262,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 262,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
  className: "bulb purple-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#purple-blur-7)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 270,
  y: 45,
  fill: "#9626A8",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 270,
  y: 45,
  fill: "#9626A8",
  rx: 2
}))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter38_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 90,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter39_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 98,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter40_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 106,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter41_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 114,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter42_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 122,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter43_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 130,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter44_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 138,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter45_d_2227_10600)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 146,
  y: 45,
  fill: "#070707",
  rx: 2
}))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#blue-blur-0)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 90,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 90,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-1",
  filter: "url(#blue-blur-1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 98,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 98,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-2",
  filter: "url(#blue-blur-2)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 106,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 106,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-3",
  filter: "url(#blue-blur-3)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 114,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 114,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-4",
  filter: "url(#blue-blur-4)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 122,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 122,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-5",
  filter: "url(#blue-blur-5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 130,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 130,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-6",
  filter: "url(#blue-blur-6)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 138,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 138,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
  className: "bulb blue-bulb"
}, /*#__PURE__*/React.createElement("g", {
  className: "blur blue-blur-7",
  filter: "url(#blue-blur-7)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 11,
  x: 146,
  y: 45,
  fill: "#45B3BA",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 7,
  x: 146,
  y: 45,
  fill: "#45B3BA",
  rx: 2
}))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 70,
  fill: "#262938",
  className: "white-light"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 76,
  fill: "#262938",
  className: "white-light"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 82,
  fill: "#262938",
  className: "white-light"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 88,
  fill: "#262938",
  className: "white-light"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 94,
  fill: "#262938",
  className: "white-light"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 100,
  fill: "#262938",
  className: "white-light"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 106,
  fill: "#262938",
  className: "white-light"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 112,
  fill: "#262938",
  className: "white-light"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 118,
  fill: "#262938",
  className: "white-light"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 124,
  fill: "#262938",
  className: "white-light"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 130,
  fill: "#262938",
  className: "white-light"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 136,
  fill: "#262938",
  className: "white-light"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 142,
  fill: "#262938",
  className: "white-light"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 148,
  fill: "#262938",
  className: "white-light"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 154,
  fill: "#262938",
  className: "white-light"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 160,
  fill: "#262938",
  className: "white-light"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 166,
  fill: "#262938",
  className: "white-light"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 172,
  fill: "#262938",
  className: "white-light"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 178,
  fill: "#262938",
  className: "white-light"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 184,
  fill: "#262938",
  className: "white-light"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 190,
  fill: "#262938",
  className: "white-light"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 196,
  fill: "#262938",
  className: "white-light"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 202,
  fill: "#262938",
  className: "white-light"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 208,
  fill: "#262938",
  className: "white-light"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 214,
  fill: "#262938",
  className: "white-light"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 220,
  fill: "#262938",
  className: "white-light"
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 226,
  fill: "#262938",
  className: "white-light"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 232,
  fill: "#262938",
  className: "white-light"
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 238,
  fill: "#262938",
  className: "white-light"
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 244,
  fill: "#262938",
  className: "white-light"
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 250,
  fill: "#262938",
  className: "white-light"
})), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 256,
  fill: "#262938",
  className: "white-light"
})), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 262,
  fill: "#262938",
  className: "white-light"
})), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 268,
  fill: "#262938",
  className: "white-light"
})), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 274,
  fill: "#262938",
  className: "white-light"
})), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 280,
  fill: "#262938",
  className: "white-light"
})), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 286,
  fill: "#262938",
  className: "white-light"
})), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 292,
  fill: "#262938",
  className: "white-light"
})), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 70,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 76,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 82,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 88,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 94,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 100,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 106,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 112,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 118,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 124,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 130,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 136,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 142,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 148,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 154,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 160,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 166,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 172,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 178,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 184,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 190,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 196,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 202,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 208,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 214,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 220,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 226,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 232,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 238,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 244,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 250,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 256,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 262,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 268,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 274,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 280,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 286,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 292,
  y: -20,
  fill: "#262938",
  className: "white-light-top"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_2227_10600",
  width: 15,
  height: 15,
  x: 141,
  y: 292,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_2227_10600",
  width: 15,
  height: 15,
  x: 100,
  y: 260,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_2227_10600",
  width: 15,
  height: 15,
  x: 247,
  y: 260,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_2227_10600",
  width: 15,
  height: 15,
  x: 207,
  y: 293,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_di_2227_10600",
  width: 236,
  height: 236,
  x: 64,
  y: 35,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 16
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "effect2_innerShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect2_innerShadow_2227_10600"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_f_2227_10600",
  width: 162,
  height: 162,
  x: 99,
  y: 69,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_i_2227_10600",
  width: 107,
  height: 26,
  x: 129,
  y: 124,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow_2227_10600"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_d_2227_10600",
  width: 27.2,
  height: 2.6,
  x: 81.4,
  y: 127.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_d_2227_10600",
  width: 27.2,
  height: 2.6,
  x: 255.4,
  y: 127.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_d_2227_10600",
  width: 27.2,
  height: 2.6,
  x: 81.4,
  y: 134.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_d_2227_10600",
  width: 27.2,
  height: 2.6,
  x: 255.4,
  y: 134.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_d_2227_10600",
  width: 27.2,
  height: 2.6,
  x: 81.4,
  y: 141.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_d_2227_10600",
  width: 27.2,
  height: 2.6,
  x: 255.4,
  y: 141.5,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.11 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_d_2227_10600",
  width: 6,
  height: 9,
  x: 213,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_d_2227_10600",
  width: 6,
  height: 9,
  x: 221,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_d_2227_10600",
  width: 6,
  height: 9,
  x: 229,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_d_2227_10600",
  width: 6,
  height: 9,
  x: 237,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_d_2227_10600",
  width: 6,
  height: 9,
  x: 245,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_d_2227_10600",
  width: 6,
  height: 9,
  x: 253,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_d_2227_10600",
  width: 6,
  height: 9,
  x: 261,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_d_2227_10600",
  width: 6,
  height: 9,
  x: 269,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_d_2227_10600",
  width: 6,
  height: 9,
  x: 89,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_d_2227_10600",
  width: 6,
  height: 9,
  x: 97,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_d_2227_10600",
  width: 6,
  height: 9,
  x: 105,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter25_d_2227_10600",
  width: 6,
  height: 9,
  x: 113,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter26_d_2227_10600",
  width: 6,
  height: 9,
  x: 121,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter27_d_2227_10600",
  width: 6,
  height: 9,
  x: 129,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter28_d_2227_10600",
  width: 6,
  height: 9,
  x: 137,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter29_d_2227_10600",
  width: 6,
  height: 9,
  x: 145,
  y: 222,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter30_d_2227_10600",
  width: 6,
  height: 9,
  x: 213,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter31_d_2227_10600",
  width: 6,
  height: 9,
  x: 221,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter32_d_2227_10600",
  width: 6,
  height: 9,
  x: 229,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter33_d_2227_10600",
  width: 6,
  height: 9,
  x: 237,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter34_d_2227_10600",
  width: 6,
  height: 9,
  x: 245,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter35_d_2227_10600",
  width: 6,
  height: 9,
  x: 253,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter36_d_2227_10600",
  width: 6,
  height: 9,
  x: 261,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter37_d_2227_10600",
  width: 6,
  height: 9,
  x: 269,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter38_d_2227_10600",
  width: 6,
  height: 9,
  x: 89,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter39_d_2227_10600",
  width: 6,
  height: 9,
  x: 97,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter40_d_2227_10600",
  width: 6,
  height: 9,
  x: 105,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter41_d_2227_10600",
  width: 6,
  height: 9,
  x: 113,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter42_d_2227_10600",
  width: 6,
  height: 9,
  x: 121,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter43_d_2227_10600",
  width: 6,
  height: 9,
  x: 129,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter44_d_2227_10600",
  width: 6,
  height: 9,
  x: 137,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter45_d_2227_10600",
  width: 6,
  height: 9,
  x: 145,
  y: 45,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2227_10600"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2227_10600",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-0",
  width: 18,
  height: 25,
  x: 84,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-1",
  width: 18,
  height: 25,
  x: 92,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-2",
  width: 18,
  height: 25,
  x: 100,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-3",
  width: 18,
  height: 25,
  x: 108,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-4",
  width: 18,
  height: 25,
  x: 116,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-5",
  width: 18,
  height: 25,
  x: 124,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-6",
  width: 18,
  height: 25,
  x: 132,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "blue-blur-7",
  width: 18,
  height: 25,
  x: 140,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-0",
  width: 18,
  height: 25,
  x: 84,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-1",
  width: 18,
  height: 25,
  x: 92,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-2",
  width: 18,
  height: 25,
  x: 100,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-3",
  width: 18,
  height: 25,
  x: 108,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-4",
  width: 18,
  height: 25,
  x: 116,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-5",
  width: 18,
  height: 25,
  x: 124,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-6",
  width: 18,
  height: 25,
  x: 132,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "yellow-blur-7",
  width: 18,
  height: 25,
  x: 140,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-0",
  width: 18,
  height: 25,
  x: 208,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-1",
  width: 18,
  height: 25,
  x: 216,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-2",
  width: 18,
  height: 25,
  x: 224,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-3",
  width: 18,
  height: 25,
  x: 232,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-4",
  width: 18,
  height: 25,
  x: 240,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-5",
  width: 18,
  height: 25,
  x: 248,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-6",
  width: 18,
  height: 25,
  x: 256,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "green-blur-7",
  width: 18,
  height: 25,
  x: 262,
  y: 215,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-0",
  width: 18,
  height: 25,
  x: 208,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-1",
  width: 18,
  height: 25,
  x: 216,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-2",
  width: 18,
  height: 25,
  x: 224,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-3",
  width: 18,
  height: 25,
  x: 232,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-4",
  width: 18,
  height: 25,
  x: 240,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-5",
  width: 18,
  height: 25,
  x: 248,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-6",
  width: 18,
  height: 25,
  x: 256,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("filter", {
  id: "purple-blur-7",
  width: 18,
  height: 25,
  x: 264,
  y: 38,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2227_10600",
  stdDeviation: 3.5
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2227_10600",
  x1: 185.5,
  x2: 220,
  y1: 68,
  y2: 176.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDC0D0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDC0D0",
  stopOpacity: 0
})))));
export { SvgChip as ReactComponent };
export default __webpack_public_path__ + "static/chip.8f5c7537.svg";